import React from 'react';
import Pdf from '../../../../../../assets/icons/Pdf2';
import Xlsx from '../../../../../../assets/icons/Xlsx2';
import Home from '../../../../../../shared/components/Wrapper/Home';
import AnalyticReportCsv from '../SelectModal/analyticReportCsv';
import ReportMacroSmartExcel, {
  ReportMacroSmartPdf,
} from '../SelectModal/ReportMacroSmart';
import UnifiedReportSmartExcel, {
  UnifiedReportSmartPdf,
} from '../SelectModal/UnifiedReportSmart';

function index(props) {
  const { setToggle } = props;
  const [clickDownload, setClickDownload] = React.useState(false);
  const [UnifiedReportSmartExcelShow, setUnifiedReportSmartExcelShow] =
    React.useState(false);
  const [UnifiedReportSmartPdfShow, setUnifiedReportSmartPdfShow] =
    React.useState(false);
  const [ReportMacroSmarttPdfShow, setReportMacroSmartPdfShow] =
    React.useState(false);
  const [AnalyticReportCsvShow, setAnalyticReportCsvShow] =
    React.useState(false);
  const [ReportMacroSmartExcelShow, setReportMacroSmartExcelShow] =
    React.useState(false);

  function setBankInfoModal(e: any) {
    if (e === 'UnifiedReportSmartExcel') {
      setUnifiedReportSmartExcelShow(true);
    } else if (e === 'UnifiedReportSmartPdf') {
      setUnifiedReportSmartPdfShow(true);
    } else if (e === 'ReportMacroSmartPdf') {
      setReportMacroSmartPdfShow(true);
    } else if (e === 'ReportMacroSmartExcel') {
      setReportMacroSmartExcelShow(true);
    } else if (e === 'AnalyticReportCsv') {
      setAnalyticReportCsvShow(true);
    }
  }

  return (
    <>
      <Home.ContainerPrincipal>
        <Home.TitlePrincipal>RELATORIO CONTÁBIL</Home.TitlePrincipal>
      </Home.ContainerPrincipal>
      <Home.ContainerAction>
        <Home.Action>
          <Home.ActionDesc>Relatório Unificado</Home.ActionDesc>
          <Home.ActionContent>
            <Home.ActionSelect>
              Relatório macro
              <Home.ActionContainerButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('UnifiedReportSmartPdf');
                    setClickDownload(false);
                  }}>
                  <Pdf />
                </Home.ActionSelectButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('UnifiedReportSmartExcel');
                    setClickDownload(false);
                  }}>
                  <Xlsx />
                </Home.ActionSelectButton>
              </Home.ActionContainerButton>
            </Home.ActionSelect>
            <Home.BtnAction onClick={() => setToggle(1)}>
              Visualizar
            </Home.BtnAction>
          </Home.ActionContent>
        </Home.Action>
        <Home.Action>
          <Home.ActionDesc>Relatório Fechamento</Home.ActionDesc>
          <Home.ActionContent>
            <Home.ActionSelect>
              Relatório macro
              <Home.ActionContainerButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('ReportMacroSmartPdf');
                    setClickDownload(false);
                  }}>
                  <Pdf />
                </Home.ActionSelectButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('ReportMacroSmartExcel');
                    setClickDownload(false);
                  }}>
                  <Xlsx />
                </Home.ActionSelectButton>
              </Home.ActionContainerButton>
            </Home.ActionSelect>
            <Home.ActionSelect>
              Relatório analítico
              <Home.ActionContainerButton>
                <Home.ActionSelectButton
                  onClick={() => {
                    setBankInfoModal('AnalyticReportCsv');
                    setClickDownload(false);
                  }}>
                  <Xlsx />
                </Home.ActionSelectButton>
              </Home.ActionContainerButton>
            </Home.ActionSelect>
            <Home.BtnAction onClick={() => setToggle(2)}>
              Visualizar
            </Home.BtnAction>
          </Home.ActionContent>
        </Home.Action>
      </Home.ContainerAction>
      <UnifiedReportSmartExcel
        show={UnifiedReportSmartExcelShow}
        onHide={() => setUnifiedReportSmartExcelShow(false)}
      />
      <UnifiedReportSmartPdf
        show={UnifiedReportSmartPdfShow}
        onHide={() => setUnifiedReportSmartPdfShow(false)}
        validation={setClickDownload}
        Clicked={clickDownload}
      />
      <ReportMacroSmartExcel
        show={ReportMacroSmartExcelShow}
        onHide={() => setReportMacroSmartExcelShow(false)}
        validation={setClickDownload}
        Clicked={clickDownload}
      />
      <ReportMacroSmartPdf
        show={ReportMacroSmarttPdfShow}
        onHide={() => setReportMacroSmartPdfShow(false)}
        validation={setClickDownload}
        Clicked={clickDownload}
      />
      <AnalyticReportCsv
        show={AnalyticReportCsvShow}
        onHide={() => setAnalyticReportCsvShow(false)}
      />
    </>
  );
}

export default index;
